<script lang="ts">
    import { cn } from "../cn";
    export let variant: "default" | "destructive" | "warning" = "default";
    export let disabled = false;
    let className = "";
    export { className as class };

    const variants: Record<string, string> = {
        default:
            "text-[var(--foreground)] hover:bg-[var(--accent)] hover:text-[var(--accent-foreground)]",
        destructive:
            "text-[var(--destructive)] hover:bg-[var(--destructive)]/10",
        warning:
            "text-[var(--warning)] hover:bg-[var(--warning)]/10",
    };
</script>

<button
    type="button"
    on:click
    {disabled}
    class={cn(
        "w-full text-left flex items-center gap-2 px-2.5 py-1.5 text-xs rounded-sm cursor-pointer transition-colors disabled:opacity-50 disabled:cursor-not-allowed",
        variants[variant],
        className,
    )}
    role="menuitem"
>
    <slot />
</button>
